import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { MfsUser, MfsLimitedAccessConfig } from '@feature/_app_modules/mojo-for-suppliers/user-admin/models/mfs-user';

import { DisableApiResult, InviteApiResult, UserApiResult } from '@feature/_app_modules/mojo-for-suppliers/user-admin/models/user-api-result';
import { BrandService } from '@brand/services/brand.service';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserAdminHttpService {

  private brand: string;


  private getMfsAdminUrl(path: string) {
    return this.urlBuilder.getIdentityServerUrl(`mfsuseradmin/${path}`);
  }

  getLimitedAccessConfig() {
    return this.http.get<MfsLimitedAccessConfig>(this.urlBuilder.getIdentityServerUrl('limitedaccess')).pipe(tap(
      x => {
        const y = x;
        console.log(y);
      }) );
  }


  getUsers() {
    return this.http.get<MfsUser[]>(this.getMfsAdminUrl('getusers'));
  }

  createUser(user: MfsUser) {
    const usersUrl = this.getMfsAdminUrl('createuser');

    const body = {
      email: user.email,
      limitedAccessConfig: user.limitedAccessConfig,
      roleId: user.roleId
    };

    return this.http.post<UserApiResult>(usersUrl, body);

  }

  updateUser(user: MfsUser) {
    const usersUrl = this.getMfsAdminUrl('updateuser');

    const body = {
      userId: user.mfsUserId,
      email: user.email,
      limitedAccessConfig: user.limitedAccessConfig,
      roleId: user.roleId
    };

    return this.http.post<UserApiResult>(usersUrl, body);

  }

  inviteUsers(users: MfsUser[]) {
    const usersUrl = this.getMfsAdminUrl('sendpasswordreset');

    const body = {
      brandId: this.brand,
      usersToInvite: users.map(u => {
        return {
          email: u.email,
          mojoPlatformUserId: u.mfsUserId
        }
      })
    }

    return this.http.post<InviteApiResult[]>(usersUrl, body);

  }

  deactivateUsers(users: MfsUser[]) {
    const usersUrl = this.getMfsAdminUrl('disableusers');

    const body = {

      usersToDisable: users.map(u => {
        return {
          email: u.email,
          mojoPlatformUserId: u.mfsUserId
        }
      })
    }

    const result = this
      .http
      .request<DisableApiResult[]>('delete', usersUrl, { body: body });

    return result;

  }


  constructor(
    brandService: BrandService,
    private readonly http: HttpClient,
    private readonly urlBuilder: UrlBuilderService
  ) {
    brandService.getCustomerBrandName().subscribe((brandName: string) => {
      this.brand = brandName;
    });
  }
}
